// Backend routes for the Engage-scoped AI Voice Agent.
export const ENGAGE_AI_CALLER = {
  DASHBOARD:        'engage/ai-caller/dashboard/',
  CALLS_LIST:       'engage/ai-caller/calls/',
  CALLS_INITIATE:   'engage/ai-caller/calls/initiate/',
  CAMPAIGNS:        'engage/ai-caller/campaigns/',
  CAMPAIGNS_PREVIEW:'engage/ai-caller/campaigns/preview/',
  BUCKET:           'engage/ai-caller/bucket/',
  BUCKET_CLEAR:     'engage/ai-caller/bucket/clear/',
  CONFIG:           'engage/ai-caller/config/',
};

export const OUTCOME_BADGE = {
  demo_booked:        'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  qualified:          'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  callback_requested: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  not_interested:     'bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-300',
  disqualified:       'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  no_answer:          'bg-gray-100 text-gray-600 dark:bg-gray-800/50 dark:text-gray-400',
  voicemail:          'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  error:              'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

export const STATUS_BADGE = {
  queued:      'bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-300',
  ringing:     'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  in_progress: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  completed:   'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  failed:      'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  no_answer:   'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  busy:        'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  cancelled:   'bg-gray-100 text-gray-600 dark:bg-gray-800/50 dark:text-gray-400',
};

export const PRIORITY_BADGE = {
  high:   'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  medium: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  low:    'bg-slate-100 text-slate-600 dark:bg-slate-900/30 dark:text-slate-300',
};

export const formatDuration = (secs) => {
  if (!secs) return '—';
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return m ? `${m}m ${s}s` : `${s}s`;
};

export const prettyOutcome  = (o) => (o || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
export const prettyStatus   = (s) => (s || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

// Two-decimal INR with the ₹ prefix. Nulls / undefined → em-dash.
export const formatInr = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  return `₹${n.toFixed(2)}`;
};

// English-only for now — regional labels can be added back when STT/TTS
// support is verified per language.
export const LANGUAGE_LABEL = {
  en: 'English',
};
